import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import Footer from './Footer';
import { LANGUAGES } from '../../utils/constants';
import NavBar from './NavBar';
import ScrollButton from '../../components/ScrollButton/ScrollButton';
import { getBrowserLocaleFromIp } from '../../utils/localeDetector';
import { setLanguage } from '../../ducks/settings';
import siteMessages from './siteMessages';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  onClickLogin: () => void;
  onClickLogout: () => void;
}

export let ERROR_MESSAGE: string;

const RootLayout = (props: Props) => {
  const intl = useIntl();
  const { lang } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang) {
      dispatch(
        setLanguage(LANGUAGES.find((l) => l.locale === lang) || LANGUAGES[0])
      );
      ERROR_MESSAGE = intl.formatMessage({
        ...siteMessages.TOAST_ERROR_MESSAGE
      });
    } else {
      getBrowserLocaleFromIp().then((locale) => {
        navigate(`/${locale}/${location.pathname.substring(1)}`);
      });
    }
  }, [lang]);

  return (
    <div className="full-screen">
      <header>
        <NavBar
          onClickLogin={props.onClickLogin}
          onClickLogout={props.onClickLogout}
        />
      </header>
      <main>
        <Outlet />
        <ScrollButton />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default RootLayout;
